import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useResetFinalSchema } from "@ryde/redux";

import { MuiButton } from "../../controls";
import { ViewDropdownOptionStyled } from "./view.styled";

export const ResetDefaultsButton: FC = () => {
  const { t } = useTranslation();
  const { resetFinalSchema } = useResetFinalSchema();

  return (
    <ViewDropdownOptionStyled>
      <MuiButton
        muiVariant="text"
        className="ViewDropdownOption-ResetButton"
        onClick={resetFinalSchema}
      >
        {t("view.resetDefaults")}
      </MuiButton>
    </ViewDropdownOptionStyled>
  );
};
